import React, { useEffect, useState } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import home_card1 from "../assets/images/home_card1.svg";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import Button from "@restart/ui/esm/Button";

import companiesLogo from "../assets/images/companiesLogo.png";
import { imageUrl, URL } from "../Config/apiUrl";
import { Get } from "../Axios/AxiosFunctions";
import BodyLoader from "../Components/BodyLoader";

const AboutUs = ({ footerStyle, setfooterStyle }) => {
  const [isApiCall, setIsApiCall] = useState(true);
  const [pageData, setPageData] = useState(null);
  const [allServices, setAllServices] = useState([]);
  const [allServicesCompany, setAllServicesCompany] = useState([]);
  const [allServicesGoal, setAllServicesGoal] = useState([]);

  const array = [
    {
      pic: home_card1,
      title: "Hire an employee",
      des: "As you probably know it with traditional temp agencies, you can always hire an employee for a shorter or longer period. Here we have just cut away all the superfluous and digitized the whole process for you.",
    },
    {
      pic: home_card1,
      title: "Try and Hire",
      des: "You can choose to hire the employee for a period of time to clarify whether it is the right candidate for a permanent job in your company.",
    },
    {
      pic: home_card1,
      title: "Direct employment",
      des: "Our screening tools are so powerful that several companies are offering our graduates permanent employment from day 1.",
    },
  ];

  const arrayLogo = [
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
    { logo: companiesLogo },
  ];
  const history = useHistory();

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);

  // getdata
  const getdata = async () => {
    const url = URL("general/web/selected-page?name=about_us");
    const response = await Get(url);
    if (response !== undefined) {
      setPageData(response?.data?.data?.about_us);
      setAllServices(response?.data?.allServices);
      setAllServicesCompany(response?.data?.allServicesCompany);
      setAllServicesGoal(response?.data?.allServicesGoal);
    }

    setIsApiCall(false);
  };

  useEffect(() => {
    getdata();
  }, []);

  if (isApiCall) {
    return <BodyLoader />;
  }

  return (
    <div>
      <div className="About_us_banner">
        <Container>
          <Row>
            <Col className="text-center aboutus_banner whito">
              <h2>{pageData?.heading}</h2>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="small_container aboutUs_video">
        <Row>
          <Col>
            <h3 className=" text-center mb-4 mt-5">
              {/* <span className="regular"> About </span> JOBSTER */}
              {pageData?.aboutSection1Heading}
            </h3>
            <p className="mb-5">
              {/* We have developed an intelligent recruitment tool that helps
              companies find the qualified employees your company is missing.
              The algorithm is developed in such a way that the user's min. 10
              different parameters to create the perfect match between employer
              and employee. */}
              {pageData?.aboutSection1Description}
            </p>
            <div className="mb-5">
              <ReactPlayer
                url={`${imageUrl}${pageData?.cover_image}`}
                className="html5_video"
                controls
              />
            </div>
          </Col>
        </Row>
      </Container>

      <div className="companies_gray_bg mt-5 ">
        <Container className="small_container">
          <Row>
            <div className="text-center">
              <h3 className="mb-3">
                {/* <span className="regular"> Why </span> Choose Us */}
                {pageData?.aboutSection2Heading}
              </h3>
              <p className="mb-5">{pageData?.aboutSection2Description}</p>
            </div>
            {allServices.map((item, i) => {
              return (
                <Col md={4} key={item?._id}>
                  <Card className="home_card1 home_card_main companies_card">
                    <div className="img_div">
                      <Card.Img
                        variant="top"
                        src={`${imageUrl}${item?.icon}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = home_card1;
                        }}
                      />
                    </div>
                    <Card.Body>
                      <Card.Title className="mb-4">
                        <h4> {item?.title} </h4>
                      </Card.Title>
                      <Card.Text>{item?.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      </div>

      <Container className="small_container">
        <Row>
          <Col>
            <h3 className="text-center mt-5 mb-5">
              {pageData?.aboutSection3Description}
              {/* <span className="regular">Reputable </span>
              Companies have <br /> worked with us */}
            </h3>
          </Col>
        </Row>

        <Row className="company_logo_row">
          {allServicesCompany.map((item, i) => {
            return (
              <Col className="mb-4 company_logo_r" key={item?._id}>
                <Image src={`${imageUrl}${item?.icon}`} />
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

export default AboutUs;
